const CHECK_TIMER = {}
const RESET_TIMER = {}
const CHECK_INTERVAL = 200
export default {
    data () {
        return {
            page_scrollling: false,
            __CHECKING_SCROLL: false,
        }
    },
    onUnload () {
        CHECK_TIMER[this._uid] && clearTimeout(CHECK_TIMER[this._uid])
        RESET_TIMER[this._uid] && clearTimeout(RESET_TIMER[this._uid])
    },
    onPageScroll (e) {
        if (this.__CHECKING_SCROLL) {
            return
        }
        this.__CHECKING_SCROLL = true
        this.page_scrollling = true

        CHECK_TIMER[this._uid] && clearTimeout(CHECK_TIMER[this._uid])
        RESET_TIMER[this._uid] && clearTimeout(RESET_TIMER[this._uid])

        CHECK_TIMER[this._uid] = setTimeout(() => {
            this.__CHECKING_SCROLL = false
            RESET_TIMER[this._uid] && clearTimeout(RESET_TIMER[this._uid])
            RESET_TIMER[this._uid] = setTimeout(() => {
                if (!this.__CHECKING_SCROLL) {
                    this.page_scrollling = false
                }
            }, CHECK_INTERVAL)
        }, CHECK_INTERVAL)
    }
}